module.exports = __webpack_public_path__ + "media/images/large-human-021ab965c0da3f88d900652ac408701b.svg";